import { Component, inject } from '@angular/core';
import { AppInformationService, AuthService, BrewersUnitOfWork } from 'app/core/core.module';
import { Product, ProductMaterial, ProductUnitOfMeasure, QuoteLine } from 'app/core/model/entity-model';
import DataSource from 'devextreme/data/data_source';
import validationEngine from 'devextreme/ui/validation_engine';
import { Subject } from 'rxjs';

@Component({
    standalone: false,
    selector: 'app-quote-line-dialog',
    templateUrl: './quote-line-dialog.component.html',
    styleUrl: './quote-line-dialog.component.scss',
})
export class QuoteLineDialogComponent {
    uow = inject(BrewersUnitOfWork);
    auth = inject(AuthService);
    appInfo = inject(AppInformationService);

    result = new Subject<{ success: boolean; value?: QuoteLine }>();
    mode?: 'delivery';
    quantity: number = null;
    quoteLine: QuoteLine;
    quoteId: number;
    lineNumber: number;
    productsDS: DataSource;
    products: Product[];
    uoms: ProductUnitOfMeasure[];

    async ngOnInit() {
        await this.appInfo.pleaseWaitShow();
        if (!this.quoteLine) {
            this.quoteLine = this.uow.quoteLines.createEntity({
                quantity: this.quantity,
                price: null,
                quoteId: this.quoteId,
                lineNumber: this.lineNumber,
                created: new Date(),
                createdBy: this.auth.currentUser.userName,
            });
        }

        this.uoms = await this.uow.productUnitsOfMeasure.whereActive();

        const material = this.mode === 'delivery' ? ProductMaterial.Materials.Delivery : null;
        const products = await this.uow.getProducts(material);
        // exclude generic delivery product
        this.products = products.filter((product) => product.id !== Product.Types.Delivery);
        this.productsDS = new DataSource({ store: this.products, paginate: true });
        await this.appInfo.pleaseWaitHide();
    }

    productChanged = (e: any) => {
        const product = this.products.find((p) => p.id === e.value);
        this.quoteLine.partNumber = product?.partNumber;
        this.quoteLine.unitOfMeasureId = product?.inventoryUomId;
        this.quoteLine.unit = product?.inventoryUom.name;
        this.quoteLine.price = product?.basePrice;
        this.quoteLine.description = product?.description;
    };

    save() {
        const success = this.valid();
        if (!success) return;

        this.result.next({ success: true, value: this.quoteLine });
    }

    cancel() {
        this.quoteLine.entityAspect.rejectChanges();

        this.result.next({ success: false });
    }

    valid() {
        const groupConfig = validationEngine.getGroupConfig('quoteLineValidationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('quoteLineValidationGroup');
            return result.isValid;
        } else return false;
    }
}
